<template>
  <div class="app-section">
    <div class="container">
      <h3 v-if="title" class="title" v-html="title"></h3>
        <p v-if="subTitle" class="sub-title" v-html="subTitle"></p>
        <section-button v-if="btnText" :btnText="btnText"/>
        <div class="row">
          <div class="col-sm-4 col-xs-6 box">
            <div class="box">
              <h3 v-if="heading" class="heading" v-html="heading"></h3>
              <p v-if="content" class="small" v-html="content"></p>
              <button v-if="button">{{ button }}</button>
            </div>
          </div>
          <div class="img-container" v-if="getStarted" :style="{backgroundImage: 'url('+image+')'}"></div>
          <div v-else class="col-xs-6 img-container" :class="{'col-sm-8': removeSpacer, 'col-sm-4': !removeSpacer}">
            <div id="image" class="image">
              <!-- <img :id="'ip'+index" src="../assets/wire1-rendered.svg" style="display: none;"> -->
              <div v-if="wireframe">
                <div v-if="removeSpacer">
                  <svg style="opacity: 0; display: inline-block" viewBox="0 0 694.10303 400.01801" :id="'svg' + index" xmlns="http://www.w3.org/2000/svg" v-html="svg1"></svg>
                  <svg style="display: none" viewBox="0 0 694.10303 400.01801" :id="'ip' + index" xmlns="http://www.w3.org/2000/svg" v-html="svg2"></svg>
                </div>
                <div v-else>
                  <svg style="opacity: 0; display: inline-block" viewBox="0 0 210 429" :id="'svg' + index" xmlns="http://www.w3.org/2000/svg" v-html="svg1"></svg>
                  <svg style="display: none" viewBox="0 0 210 429" :id="'ip' + index" xmlns="http://www.w3.org/2000/svg" v-html="svg2"></svg>
                </div>
              </div>
              <transition v-else
              name="bounce"
              :enter-active-class="animEnter"
              :leave-active-class="animLeave"
              >
              <img class="img-responsive center-block" v-if="enter" :src="image">
              </transition>
              <!-- <object id="my-svg" type="image/svg+xml" :data="image"></object> -->
            </div>
          </div>
        <div class="col-sm-4 hidden-sm hidden-xs spacer"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import SectionButton from '@/components/SectionButton'
  import AppFooter from '@/components/AppFooter'

  export default {
    name: 'app-section',
    components: { SectionButton, AppFooter },
    props: [
      'heading',
      'content',
      'btnText',
      'image',
      'background',
      'order',
      'cta',
      'button',
      'enter',
      'index',
      'alignBottom',
      'animEnter',
      'animLeave',
      'appFooter',
      'getStarted',
      'title',
      'subTitle',
      'wireframe',
      'svg1',
      'svg2',
      'removeSpacer'
    ],
    data () {
      return {
      }
    },
    methods: {
      buildApp() {
        console.log('test');
      }
    },
    mounted() {
      // let vm = this;
      // this.$eventHub.$on('animate', function(item) {
      //   vm.animate(item);
      // })
    }
  }
</script>

<style scoped lang="sass">
  .app-section
    padding: 80px 0 50px 0
    // overflow: hidden
    color: white
    .container
      // margin: 10% auto
    .title
      color: white
      font-size: 3.5em
      font-weight: 600
      letter-spacing: 1px
      position: relative
      top: -20px
      text-align: center
      @media screen and (max-width: 767px)
        font-size: 1.5em
      .sub-title
        color: white
        max-width: 700px
        margin: 10px auto
        letter-spacing: 0
        line-height: 20px
        text-align: center
        font-size: 16px
        font-weight: 300
        @media screen and (max-width: 767px)
          font-size: 12px
    .row
      display: flex
      align-items: center
      .box
        align-items: center
        position: relative
        z-index: 999
        h3
          font-size: 2.5em
          letter-spacing: 1px
          margin: 0
          font-weight: 600
          color: white
          text-transform: uppercase
          .highlight
            color: limegreen
          @media screen and (max-width: 767px)
            font-size: 1.2em
        .small
          font-size: 1em
          color: white
          margin: 20px 0
          font-weight: 300
          @media screen and (max-width: 767px)
            font-size: 12px
            margin: 10px 0
        button
          // position: absolute
          // z-index: 999999
          border: 2px solid limegreen
          border-radius: 3px
          background: transparent
          color: limegreen
          padding: 10px 30px
          cursor: pointer
          transition: 300ms
          &:hover
            background: limegreen
            color: white
          @media screen and (max-width: 767px)
            font-size: 12px
            padding: 10px 20px
      .image
        // max-height: 450px
        // max-height: 422px
        text-align: center
        img
          vertical-align: middle
          @media screen and (max-width: 992px)
            width: 100%
        svg
          vertical-align: middle
          max-width: 210px
          max-height: 430px
          @media screen and (max-width: 992px)
            width: 100%

  .get-started
    .title
      top: 0
      text-transform: uppercase
      color: black
      // position: relative
      // z-index: 99
    .sub-title
      font-size: 1.5em
      text-align: center
      color: black
      // position: relative
      // z-index: 99
      @media screen and (max-width: 767px)
        font-size: 14px
        font-weight: 400
    #section-button
      box-shadow: none
    .box
      display: none
    .spacer
      display: none
    .img-container
      position: relative
      top: 50px
      margin-top: 20px
      height: 500px
      width: 100%
      background-repeat: no-repeat
      background-position: center center
      background-size: contain
      @media screen and (max-width: 767px)
        background-size: contain
        height: 200px
    #section-button
      position: relative
      top: 50px
  .align-bottom
    height: 100vh
    .row
      flex-direction: column
      height: 100%
      max-width: 700px
      margin: 0 auto
      &>div
        text-align: center
        width: 100%
        &.box
          position: relative
          top: -50px
          @media screen and (max-width: 992px)
            max-width: 500px
        &.img-container
          position: absolute
          bottom: -20px
          max-width: 500px
  .fp-auto-height
    .app-section
      padding: 0
      .container
        padding: 130px 0 20px 0
        @media screen and (max-width: 992px)
          padding: 90px 0 20px 0
        @media screen and (max-width: 767px)
          padding: 70px 0 20px 0
      .title
        font-size: 2em
        @media screen and (max-width: 767px)
          font-size: 1.2em
          letter-spacing: 0
          font-weight: 400
  .remove-spacer
    .title
      color: black
    .sub-title
      color: black
    .row
      flex-direction: row-reverse
      @media screen and (max-width: 767px)
        flex-direction: column
        >div
          width: 100%
      .box
        .small
          color: black
      .image
        svg
          max-width: initial
          max-height: initial
    .spacer
      display: none
</style>



// WEBPACK FOOTER //
// AppSection.vue?161a5700